module.exports = __webpack_public_path__ + "static/media/1f623.4c36b410.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f623.svg
// module id = 617
// module chunks = 1